<button #buttonPickerDataSimple
  [class]="'w-[130px] common-button__text-border-with-arrow common-button__text-border-with-arrow--' + item.typeButton"
  [ngClass]="{'common-button__text-border-with-arrow--error': item.error}"
  [disabled]="disabled"
  (click)="toggleFilter($event)">
  <input-date class="common-text-input__container-input"
    [disabled]="disabled"
    [input]="finishIntervalDate"
    [field]="pickerDataSimple.inputDateField"
    (output)="outputDate($event)">
  </input-date>
  <i class="lf-icon-calendar common-icon__md"></i>
</button>
<!-- @if(item.error){
  <div class="common-text-input__mandatory-tag">
    <span>{{pickerDataSimple.errorText}}</span>
  </div>
} -->
<p-overlayPanel #calendarFieldDateOverlay
  styleClass="common-date__overlay-calendar">
  <ng-template pTemplate="content">
    <p-calendar #calendarDate
      class="common-date__calendar"
      [(ngModel)]="finishIntervalDate"
      [inline]="true"
      [dateFormat]="'dd/mm/yy'"
      [hourFormat]="'24'"
      [firstDayOfWeek]="1"
      [minDate]="pickerDataSimple.minDate"
      (onSelect)="changeInDate($event)">
      <ng-template pTemplate="previousicon">
        <i class="lf-icon-angle-left common-icon__md common-icon__main"></i>
      </ng-template>
      <ng-template pTemplate="nexticon">
        <i class="lf-icon-angle-right common-icon__md common-icon__main"></i>
      </ng-template>
    </p-calendar>
  </ng-template>
</p-overlayPanel>
